import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bg-gray-darker theme-light:bg-gray-lighter bottom-48 right-24 border-2 border-white rounded-full w-12 p-3"
}
const _hoisted_2 = { class: "text-center total" }
const _hoisted_3 = {
  key: 1,
  class: "fixed bg-gray-darker theme-light:bg-gray-lighter bottom-28 right-24 border-2 rounded-full w-12 p-3"
}
const _hoisted_4 = { class: "text-center mention" }

import { ref } from 'vue';
	import { useRooms } from '@/store/store';
	import { watchEffect } from 'vue';
	
export default /*#__PURE__*/_defineComponent({
  __name: 'InRoomNotifyMarker',
  setup(__props) {

	const rooms = useRooms();

	let totalUnreadCount = ref<number | undefined>(0);
	let totalMentionCount = ref<number | undefined>(0);

	watchEffect(() => {
		totalUnreadCount.value = rooms.unreadMessageNotification();
		totalMentionCount.value = rooms.unreadMentionNotification();
	});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(totalUnreadCount) && _unref(totalUnreadCount) > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Icon, { type: "message" }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(totalUnreadCount)), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(totalMentionCount) && _unref(totalMentionCount) > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Icon, { type: "mention" }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(totalMentionCount)), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})